import { render, staticRenderFns } from "./joinclazz.vue?vue&type=template&id=7f0133d5&scoped=true&"
import script from "./joinclazz.vue?vue&type=script&lang=js&"
export * from "./joinclazz.vue?vue&type=script&lang=js&"
import style0 from "./joinclazz.vue?vue&type=style&index=0&id=7f0133d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0133d5",
  null
  
)

export default component.exports